// extracted by mini-css-extract-plugin
export default {"section":"EditorOptionWatermarkSection_section__oJIu8","title":"EditorOptionWatermarkSection_title__tJ-WO"};